import {
	SET_CURRENT_MAP,
	UPDATE_MAP,
	UPDATE_MAP_SEARCH_LIST,
	SEARCHING_MAPS,
	DONE_SEARCHING_MAPS,
	UPDATE_PLACES,
	SET_PURCHASE_MAP,
	SHOW_PURCHASE_MAP,
	HIDE_PURCHASE_MAP,
	UPDATE_DATE,
	UPDATE_STORM_DATA,
	// Live weather center
	SUBMIT_MESSAGE,
	DELETE_MESSAGE,
	CLEAR_MESSAGES,
	SET_CHAT_STATUS,
	VIEW_CHAT,
	VIEW_SETTINGS,
	UPDATE_SCREEN_NAME,
	UPDATE_AVATAR,
	UPDATE_LWC_FEED,
	UPDATE_AVATARS
} from 'constants';

export const message = (state = {
	key : '', //Unique message key.
	creator : {
		id : '', //The unique id of the creator user.
		screen_name : '',
		admin : false, //Detects if creator is super-user.
	},
	avatar : 'https://hailtrace.atlassian.net/secure/useravatar?avatarId=10349',
	body : '', //Message body.
	timestamp : null, //DateTime of the message's creation.

}, action) => {
	let {payload, type} = action;
	//var payload = action.payload
	//var type = action.type
	switch(type) {
		case SUBMIT_MESSAGE:
			//return Object.assign({},state,payload);
			return {
				...state,
				...payload
			}
		case UPDATE_SCREEN_NAME: // {type : UPDATE_SCREEN_NAME, payload: {id : '', screen_name : ''}}
			if(state.creator.id == payload.id)
				return {
					...state,
					creator : {
						...state.creator,
						screen_name : payload.screen_name
					}
				}
			else
				return state;
		case UPDATE_AVATAR:
			return {
				...state,
				creator : {
					...state.creator,
					avatar : payload.avatar
				}
			}
		default:
			return state;
	}
	return state;
}

export const liveWeatherCenter = (state = {
		messages: [], // For testing only
		// userMessageSettings : {
		// 	bg_color : '#333333',
			// avatar : 'https://hailtrace.atlassian.net/secure/useravatar?avatarId=10349',
		// 	screen_name : 'User'
		// },
		default_avatar : 'https://hailtrace.atlassian.net/secure/useravatar?avatarId=10349',
		status : {},
		viewSettings: false, // Boolean to detect whether the user wants to view the chat
		avatars : [],
		feed_url: ''
	}, action) => {
	switch(action.type) {
		case UPDATE_LWC_FEED:
			return { ...state, feed_url: action.payload };
		case SUBMIT_MESSAGE:
			//return Object.assign({},state,{ messages: state.messages.concat([message(null, action)]) })
			return {...state, messages: [...state.messages, message(null, action)] }
		case DELETE_MESSAGE:
			let index;
			let element = state.messages.find((m, i) => {
				if (m.timestamp === action.payload.timestamp) {
					index = i;
					return true;
				}
			});
			return {...state, messages: [...state.messages.slice(0, index),
				...state.messages.slice(parseInt(index + 1), parseInt(state.messages.length))]
			}
		case CLEAR_MESSAGES:
			return {...state, messages: []}
		case SET_CHAT_STATUS:
			return {...state, status : action.payload}
		case VIEW_CHAT:
			return Object.assign({}, state, {viewSettings: action.payload.viewSettings})
		case VIEW_SETTINGS:
			return Object.assign({}, state, {viewSettings: action.payload.viewSettings})
		case UPDATE_SCREEN_NAME:
			// Rename usernames when they change based on action.payload userId
			return {...state, messages : state.messages.map(m => message(m, action))}
		case UPDATE_AVATARS:
			return {...state, avatars : action.payload.avatars}
		case UPDATE_AVATAR:
			return {...state, messages : state.messages.map(m => message(m, action))}

		default:
			return state;
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/live_weather_center.js